export const DISCOUNT_TYPE_VOUCHER = 'voucher';
export const DISCOUNT_TYPE_MEMBERSHIP = 'membership';
